<i18n>
{
  "en": {
    "profit": "Profit increase",
    "profitLabel": "Contribution to margin",
    "timeLabel": "Average diner time decrease",
    "loading": "Loading..."
  },
  "es": {
    "profit": "Incremento porcentual de la rentabilidad",
    "profitLabel": "Contribución al margen",
    "timeLabel": "Disminución de tiempo medio",
    "loading": "Cargando..."
  }
}
</i18n>
<template>
  <v-card class="mb-0">
    <v-card-subtitle class="body-1 py-0 pl-8 pt-2" v-text="title"/>
    <v-tooltip top v-if="!isChartLoaded">
      <template v-slot:activator="{ on, attrs }">
       <div class="d-flex justify-center flex-column ma-5"
            v-bind="attrs" v-on="on">
         <v-skeleton-loader type="text"></v-skeleton-loader>
        </div>
      </template>
      <span>{{$t('loading')}}</span>
    </v-tooltip>
    <div class="d-flex justify-center flex-column" v-if="isChartLoaded">
      <div class="d-flex justify-center">
        <missing-part-doughnut-chart v-on="$listeners"
                                     :chart-data="chartData" :options="chartOptions"
                                     :percentage="75"
                                     class="chart"/>
      </div>
      <div class="chart-numbers d-flex justify-center pl-2">
        <span v-for="(inc, index) in increment" :key="index" class="pr-2" :style="`color: ${chartColors[index]}`">{{
            inc
          }}%</span>
      </div>
      <div class="chart-legend d-grid">
        <fragment v-for="(label, index) in labels" :key="index">
          <div class="box grid-center-y grid-end-x" :style="`background-color: ${chartColors[index]}`"></div>
          <div class="grid-center-y grid-start-x">{{ label }}</div>
        </fragment>
      </div>
    </div>
  </v-card>

</template>
<script>
import Component from 'vue-class-component';
import { Components, MapActions } from '@core/helpers/decorators';
import MissingPartDoughnutChart from '@ulibs/unfrontcharts/components/MissingPartDoughnutChart';
import { Prop } from 'vue-property-decorator';
import * as KPITypes from '../constants';
import KpiComponent from './KpiComponent.vue';

@Component
@Components({ MissingPartDoughnutChart })
@MapActions(['calculateProfitKPI'])
export default class ProfitChart extends KpiComponent {
  @Prop({ type: Number, default: 100 }) scale;

  isChartLoaded = false;

  kpiType = KPITypes.PERCENTAGE_PROFIT;

  chartColors = [this.$vuetify.theme.currentTheme.primary, '#00a8ff']

  emptyColor = '#efefef'

  get title() {
    return this.$t('profit');
  }

  get labels() {
    return [this.$t('profitLabel'), this.$t('timeLabel')];
  }

  get chartData() {
    const data = [];
    if (this.increment && this.increment.length > 0) {
      this.increment.forEach((increment) => {
        if (increment) {
          let internalIncrement = Math.abs(increment);
          // Do not overflow in the graph
          internalIncrement = Math.min(internalIncrement, this.scale);
          const res = this.scale - internalIncrement;
          data.push([internalIncrement, res]);
        } else {
          data.push([0, 1]);
        }
      });
    } else {
      data.push([0, 1]);
    }
    return {
      datasets: data.map((dataEl, index) => [dataEl, this.chartColors[index]]).map((pair) => ({
        backgroundColor: [pair[1], this.emptyColor], data: pair[0], borderWidth: 0
      }))
    };
  }

  get chartOptions() {
    return {
      maintainAspectRatio: false,
      backgroundColor: '#efefef',
      legend: {
        display: false
      },
      tooltips: {
        enabled: false
      },
      animation: {
        duration: 0
      }
    };
  }

  async calculate() {
    await this.calculateProfitKPI({ pointOfSaleGuid: this.$route.params.pointOfSaleGuid, isManaged: this.isManaged });
    const model = this.kpiStorage(KPITypes.PERCENTAGE_PROFIT)(`${this.$route.params.pointOfSaleGuid}-true`);
    this.value = model.kpi;
    this.increment = model.increment;
    this.isChartLoaded = true;
  }
}
</script>

<style scoped>
.chart {
  width: 200px;
  height: 200px;
}

.chart-numbers {
  position: relative;
  top: -95px;
}

.chart-legend {
  position: relative;
  top: -20px;
  row-gap: 0px;
  column-gap: 10px;
  grid-template-columns: 70px auto;
}

.v-list-item::after {
  display: none;
}

.box {
  border: 1px solid black;
  clear: both;
  height: 15px;
  width: 15px;
}
</style>
